import React from 'react';
import request from 'db-request';

// Fire-and-forget call to extend cloud (AuthMS) session, if it exists.
// Otherwise if users stay in Web3 for too long, only their mainframe session will
// be extended (by validating NSSID in APIs), while cloud session will expire
// and cause issues when/if user returns to eBanking2.
export default class KeepAlive extends React.Component {
  async componentDidMount() {
    try {
      await request.get('/security/auth/api/auth/v1/session/keep-alive', {
        baseUrl: process.env.REACT_APP_API_MARKET_BASE_URL,
      });
    } catch (ex) {
      // Silently give up on everything that you hold dear in this world...
    }
  }

  render() {
    return null;
  }
}
